(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[805],{

/***/ 7174:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apply",
      function () {
        return __webpack_require__(771);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_common_mainButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7749);
/* harmony import */ var _contexts_providers_language__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9327);
/* harmony import */ var _localization_en__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1257);
/* harmony import */ var _localization_fr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1916);





var ApplicationSuccessful = function() {
    var language = (0,_contexts_providers_language__WEBPACK_IMPORTED_MODULE_2__/* .useLanguage */ .ZK)().language;
    var successfulTexts = language === "En" ? _localization_en__WEBPACK_IMPORTED_MODULE_3__/* ["default"].applyPage.successful */ .Z.applyPage.successful : _localization_fr__WEBPACK_IMPORTED_MODULE_4__/* ["default"].applyPage.successful */ .Z.applyPage.successful;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: successfulTexts.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_mainButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                uiOnly: true,
                style: {
                    color: "var(--color-green)",
                    borderColor: "var(--color-green)"
                },
                children: successfulTexts.header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: successfulTexts.response
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: successfulTexts.validatedTitle
                    }),
                    [
                        successfulTexts.validatedMessage1,
                        successfulTexts.validatedMessage2,
                        successfulTexts.validatedMessage3, 
                    ].map(function(validationStep, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            children: [
                                "→ ",
                                validationStep
                            ]
                        }, "success-validation-step-".concat(i));
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ApplicationSuccessful);


/***/ }),

/***/ 8408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2519);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var Loader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loading),
            (_index_module_scss__WEBPACK_IMPORTED_MODULE_1___default().loading06)
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "S",
                children: "S"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "I",
                children: "I"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "L",
                children: "L"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "E",
                children: "E"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "N",
                children: "N"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "C",
                children: "C"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "I",
                children: "I"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-text": "0",
                children: "O"
            })
        ]
    });
};


/***/ }),

/***/ 771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ apply; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./src/api/clients/axios.ts
var axios = __webpack_require__(6912);
;// CONCATENATED MODULE: ./src/api/auth/signupUser.ts



var signupUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,axios/* sendRequest */.wG)({
                        method: "post",
                        url: "/auth/signup",
                        data: input
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function signupUser(input) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/components/common/mainButton/index.tsx + 1 modules
var mainButton = __webpack_require__(7749);
// EXTERNAL MODULE: ./src/contexts/providers/language.tsx
var providers_language = __webpack_require__(9327);
// EXTERNAL MODULE: ./src/localization/en.ts
var en = __webpack_require__(1257);
// EXTERNAL MODULE: ./src/localization/fr.ts
var fr = __webpack_require__(1916);
// EXTERNAL MODULE: ./src/components/application/navigationButtons/index.module.scss
var index_module = __webpack_require__(9633);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/application/navigationButtons/index.tsx






var ApplicationNavigationButtons = function(param) {
    var step = param.step, handleBack = param.handleBack, handleNext = param.handleNext;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var applyTexts = language === "En" ? en/* default.applyPage */.Z.applyPage : fr/* default.applyPage */.Z.applyPage;
    var disabled = step == 0;
    var steps = {
        0: applyTexts.applicationForm.startApplicationButton,
        1: "".concat(applyTexts.applicationForm.nextButton, "  →"),
        2: "".concat(applyTexts.applicationForm.nextButton, "  →"),
        3: "".concat(applyTexts.applicationForm.nextButton, "  →"),
        4: "".concat(applyTexts.applicationForm.nextButton, "  →"),
        5: "".concat(applyTexts.applicationForm.nextButton, "  →"),
        6: "".concat(applyTexts.applicationForm.nextButton, "  →"),
        7: "".concat(applyTexts.applicationForm.nextButton, "  →"),
        8: "Confirmer votre candidature →",
        9: "Fermer"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).applicationNavigationButtons,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(mainButton/* default */.Z, {
                onClick: handleBack,
                disabled: disabled,
                className: disabled ? (index_module_default()).disabled : undefined,
                children: [
                    "← ",
                    applyTexts.applicationForm.backButton
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                onClick: handleNext,
                children: steps[step]
            })
        ]
    });
};
/* harmony default export */ var navigationButtons = (ApplicationNavigationButtons);

// EXTERNAL MODULE: ./src/components/application/nextStep/index.module.scss
var nextStep_index_module = __webpack_require__(800);
var nextStep_index_module_default = /*#__PURE__*/__webpack_require__.n(nextStep_index_module);
;// CONCATENATED MODULE: ./src/components/application/nextStep/index.tsx







var stepScroll = [
    0,
    80,
    210,
    350,
    500
];
var getHighlightedStep = function(currentStep) {
    switch(currentStep){
        case 1:
        case 2:
        case 3:
            return 0;
        case 4:
            return 1;
        case 5:
        case 6:
            return 2;
        case 7:
        case 8:
            return 3;
        case 9:
            return 4;
    }
    return -1;
};
var ApplicationNextStep = function(param) {
    var currentStep = param.currentStep;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var applyTexts = language === "En" ? en/* default.applyPage */.Z.applyPage : fr/* default.applyPage */.Z.applyPage;
    if (currentStep < 1 || currentStep > 9) return null;
    var containerRef = (0,react.useRef)(null);
    var steps = [
        applyTexts.applicationForm.personalInformation,
        "Photo de Profil",
        "\xc0 Propos de vous",
        "Membership",
        "payment", 
    ];
    (0,react.useEffect)(function() {
        var container = containerRef.current;
        if (!!container) {
            container.scroll({
                left: stepScroll[getHighlightedStep(currentStep)],
                behavior: "smooth"
            });
        }
    }, [
        currentStep
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((nextStep_index_module_default()).applicationNextStep, " no-scrollbar"),
        ref: containerRef,
        children: steps.map(function(step, i) {
            var theme = getHighlightedStep(currentStep) == i ? "black" : "transparent-grey";
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(mainButton/* default */.Z, {
                        uiOnly: true,
                        theme: theme,
                        onClick: function(e) {
                            e.preventDefault();
                        },
                        className: (nextStep_index_module_default()).stepButton,
                        children: [
                            i + 1,
                            ". ",
                            step
                        ]
                    }),
                    " ",
                    i !== 4 && "→"
                ]
            }, i);
        })
    });
};
/* harmony default export */ var nextStep = (ApplicationNextStep);

// EXTERNAL MODULE: ./src/components/application/fieldset/index.module.scss
var fieldset_index_module = __webpack_require__(7734);
var fieldset_index_module_default = /*#__PURE__*/__webpack_require__.n(fieldset_index_module);
;// CONCATENATED MODULE: ./src/components/application/fieldset/index.tsx



var ApplicationFieldset = function(param) {
    var hidden = param.hidden, children = param.children;
    var ref = (0,react.useState)(hidden), noDisplay = ref[0], setNoDisplay = ref[1];
    (0,react.useEffect)(function() {
        if (hidden) {
            setTimeout(function() {
                return setNoDisplay(true);
            }, 500);
        } else {
            setNoDisplay(false);
        }
    }, [
        hidden
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("fieldset", {
        className: [
            (fieldset_index_module_default()).applicationFieldset,
            hidden ? (fieldset_index_module_default()).hidden : null, 
        ].join(" "),
        style: {
            display: noDisplay ? "none" : undefined
        },
        children: children
    });
};
/* harmony default export */ var fieldset = (ApplicationFieldset);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(7333);
// EXTERNAL MODULE: ./node_modules/react-calendar/dist/Calendar.css
var Calendar = __webpack_require__(9318);
// EXTERNAL MODULE: ./node_modules/react-calendar/dist/esm/index.js + 28 modules
var esm = __webpack_require__(6876);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(9647);
// EXTERNAL MODULE: ./src/components/ui/modal/index.tsx
var modal = __webpack_require__(5136);
// EXTERNAL MODULE: ./src/components/application/input/datePicker/index.module.scss
var datePicker_index_module = __webpack_require__(2471);
var datePicker_index_module_default = /*#__PURE__*/__webpack_require__.n(datePicker_index_module);
;// CONCATENATED MODULE: ./src/components/application/input/datePicker/index.tsx










var DatePicker = function(param) {
    var registrationProps = param.registrationProps, label = param.label;
    var ref = (0,react.useState)(false), modalOpen = ref[0], setModalOpen = ref[1];
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), setValue = ref1.setValue, getValues = ref1.getValues;
    var handleOpenModal = (0,react.useCallback)(function(e) {
        e.preventDefault();
        setModalOpen(true);
    }, [
        setModalOpen
    ]);
    var handleCloseModal = (0,react.useCallback)(function() {
        setModalOpen(false);
    }, [
        setModalOpen
    ]);
    var onClickDay = (0,react.useCallback)(function(date) {
        setValue("birthDate", date);
        handleCloseModal();
    }, [
        setValue,
        handleCloseModal
    ]);
    var birthDate = getValues("birthDate") ? new Date(getValues("birthDate")) : null;
    var date18YearsAgo = new Date(Date.now());
    date18YearsAgo.setFullYear(date18YearsAgo.getFullYear() - 18);
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (datePicker_index_module_default()).inputContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, registrationProps), {
                        placeholder: "dd/mm/yyyy",
                        className: (datePicker_index_module_default()).input,
                        type: "date",
                        autoComplete: "off",
                        onClick: handleOpenModal
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: (ref2 = birthDate === null || birthDate === void 0 ? void 0 : birthDate.toLocaleDateString("fr")) !== null && ref2 !== void 0 ? ref2 : "dd/mm/yyyy"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                open: modalOpen,
                onClose: handleCloseModal,
                showAnimation: "expand",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (datePicker_index_module_default()).container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                        className: (datePicker_index_module_default()).calendar,
                        tileClassName: (datePicker_index_module_default()).day,
                        nextLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiArrowRight */.Rgz, {}),
                        prevLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiArrowLeft */.Ao2, {}),
                        value: birthDate,
                        defaultValue: date18YearsAgo,
                        onClickDay: onClickDay,
                        maxDate: new Date(Date.now())
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var datePicker = (DatePicker);

// EXTERNAL MODULE: ./src/components/application/input/index.module.scss
var input_index_module = __webpack_require__(4350);
var input_index_module_default = /*#__PURE__*/__webpack_require__.n(input_index_module);
;// CONCATENATED MODULE: ./src/components/application/input/index.tsx











var ApplicationInput = function(_param) {
    var register = _param.register, label = _param.label, options = _param.options, _type = _param.type, type = _type === void 0 ? "text" : _type, fileAccept = _param.fileAccept, numberFormat = _param.numberFormat, selectOptions = _param.selectOptions, _required = _param.required, required = _required === void 0 ? false : _required, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _placeholderRequiredStar = _param.placeholderRequiredStar, placeholderRequiredStar = _placeholderRequiredStar === void 0 ? true : _placeholderRequiredStar, min = _param.min, max = _param.max, _size = _param.size, size = _size === void 0 ? 9 : _size, fileUploadText = _param.fileUploadText, handleFileUpload = _param.handleFileUpload, onChange = _param.onChange, onValueChange = _param.onValueChange, remainingInputProps = (0,_object_without_properties/* default */.Z)(_param, [
        "register",
        "label",
        "options",
        "type",
        "fileAccept",
        "numberFormat",
        "selectOptions",
        "required",
        "placeholder",
        "placeholderRequiredStar",
        "min",
        "max",
        "size",
        "fileUploadText",
        "handleFileUpload",
        "onChange",
        "onValueChange"
    ]);
    var ref = (0,index_esm/* useFormContext */.Gc)(), registration = ref.register;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var applyTexts = language === "En" ? en/* default.applyPage */.Z.applyPage : fr/* default.applyPage */.Z.applyPage;
    var registrationProps = registration(register, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
        required: required,
        min: min,
        max: max,
        onChange: onChange
    }));
    var placeHolderWithRequire = "".concat(placeholder).concat(required && placeholderRequiredStar ? "*" : "");
    var Wrapper = function(param) {
        var children = param.children;
        return type == "checkbox" || type == "radio" || type == "date" || type == "file" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (input_index_module_default()).checkboxContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: (input_index_module_default()).applicationInputLabel,
                    children: label
                }),
                children
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    className: (input_index_module_default()).applicationInputLabel,
                    children: label
                }),
                children
            ]
        });
    };
    if (type == "select") {
        if (selectOptions == undefined) return null;
        var _defaultValue;
        var defVal = (_defaultValue = remainingInputProps.defaultValue) !== null && _defaultValue !== void 0 ? _defaultValue : "$_DEFAULT_VALUE_$";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, registrationProps), {
            className: (input_index_module_default()).applicationInput,
            style: {
                width: "fit-content"
            },
            defaultValue: defVal,
            required: required,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: defVal,
                    disabled: true,
                    hidden: true,
                    children: placeholder
                }),
                selectOptions.map(function(option, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: option.value,
                        children: option.text
                    }, "".concat(register, "-select-option-").concat(i));
                })
            ]
        }));
    }
    if (type == "textarea") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, registrationProps), {
                className: (input_index_module_default()).applicationInput,
                placeholder: placeholder
            }))
        });
    }
    if (type == "file") return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, registrationProps), {
                style: {
                    display: "none"
                },
                type: "text"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                placeholder: placeHolderWithRequire,
                className: (input_index_module_default()).applicationInput,
                type: "file",
                accept: fileAccept === null || fileAccept === void 0 ? void 0 : fileAccept.join(", "),
                onChange: handleFileUpload
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: fileUploadText !== null && fileUploadText !== void 0 ? fileUploadText : applyTexts.applicationForm.uploadFileText
            })
        ]
    });
    if (type == "formatted-number") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, registrationProps), {
            className: (input_index_module_default()).applicationInput,
            placeholder: placeholder,
            size: size,
            format: numberFormat,
            onValueChange: onValueChange
        }))
    });
    if (type == "date") return /*#__PURE__*/ (0,jsx_runtime.jsx)(datePicker, {
        registrationProps: registrationProps,
        label: label
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, registrationProps), {
                placeholder: placeHolderWithRequire,
                className: (input_index_module_default()).applicationInput,
                type: type,
                size: size,
                autoComplete: "off"
            }), remainingInputProps)),
            type == "checkbox" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            type == "radio" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: placeholder
            })
        ]
    });
};
/* harmony default export */ var input = (ApplicationInput);

;// CONCATENATED MODULE: ./src/components/application/sections/aboutYou/biographyAndJoining/index.tsx





var ApplicationBiographyAndJoining = function() {
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var applyTexts = language === "En" ? en/* default.applyPage */.Z.applyPage : fr/* default.applyPage */.Z.applyPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: applyTexts.applicationForm.aboutYou.split("<br>").map(function(text, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: text
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: applyTexts.applicationForm.shortBio
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "shortBiography",
                        placeholder: applyTexts.applicationForm.shortBioText,
                        label: "short biography",
                        size: 78,
                        type: "textarea",
                        required: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: applyTexts.applicationForm.joinSilencio
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "joiningSilencio",
                        placeholder: applyTexts.applicationForm.joinSilencioText,
                        label: "Pourquoi voulez-vous rejoindre Silencio ?",
                        size: 89,
                        type: "textarea",
                        required: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var biographyAndJoining = (ApplicationBiographyAndJoining);

;// CONCATENATED MODULE: ./src/components/application/sections/aboutYou/socials/index.tsx


var ApplicationAboutYouSocials = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Profils en ligne"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Vous pouvez ajouter vos profils en ligne pour nous en dire plus \xe0 propos de vous."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Instagram"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                register: "instagram",
                placeholder: "@nomdutilisateur",
                label: "instagram",
                size: 12
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Linkedin"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                register: "linkedin",
                placeholder: "https://linkedin.com/yourprofile",
                label: "linkedin",
                size: 25
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Site Internet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                register: "website",
                placeholder: "https://yourwebsite.com",
                label: "website",
                size: 19
            })
        ]
    });
};
/* harmony default export */ var socials = (ApplicationAboutYouSocials);

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(2920);
// EXTERNAL MODULE: ./utils/token.util.ts
var token_util = __webpack_require__(1836);
// EXTERNAL MODULE: ./src/api/auth/confirmSignup.ts
var confirmSignup = __webpack_require__(7138);
// EXTERNAL MODULE: ./src/api/auth/loginUser.ts
var loginUser = __webpack_require__(172);
;// CONCATENATED MODULE: ./src/api/auth/resendConfirmationCode.ts



var resendConfirmationCode = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,axios/* sendRequest */.wG)({
                        method: "post",
                        url: "/auth/resend-confirmation-code",
                        data: input
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function resendConfirmationCode(input) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/components/application/sections/confirmationCode/index.module.scss
var confirmationCode_index_module = __webpack_require__(6931);
var confirmationCode_index_module_default = /*#__PURE__*/__webpack_require__.n(confirmationCode_index_module);
;// CONCATENATED MODULE: ./src/components/application/sections/confirmationCode/index.tsx
// type Confirm














var ApplicationConfirmationCode = function(param) {
    var goToNextStep = param.goToNextStep;
    var ref = (0,react.useState)(""), error = ref[0], setError = ref[1];
    var getValues = (0,index_esm/* useFormContext */.Gc)().getValues;
    var codeRef = (0,react.useRef)(null);
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var applyTexts = language === "En" ? en/* default.applyPage */.Z.applyPage : fr/* default.applyPage */.Z.applyPage;
    var queryClient = (0,es.useQueryClient)();
    var ref1 = (0,es.useMutation)(loginUser/* loginUser */.p, {
        onSuccess: function(res) {
            (0,token_util/* storeAuthResult */.$v)(res);
            queryClient.invalidateQueries([
                "user"
            ]);
            goToNextStep();
        }
    }), loginMutation = ref1.mutate, loginLoading = ref1.isLoading;
    var ref2 = (0,es.useMutation)(confirmSignup/* confirmSignup */.H, {
        onSuccess: function() {
            var ref = getValues(), username = ref.username, password = ref.password;
            react_toastify_esm/* toast.success */.Am.success(applyTexts.successful.validatedMessage4, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark"
            });
            loginMutation({
                username: username,
                password: password
            });
        },
        onError: function(err) {
            var ref;
            var message = (ref = err.response) === null || ref === void 0 ? void 0 : ref.data.message;
            if (typeof message === "string") {
                setError(message);
            }
        }
    }), confirmSignupMutation = ref2.mutate, confirmSignupLoading = ref2.isLoading;
    var ref3 = (0,es.useMutation)(resendConfirmationCode, {
        onSuccess: function() {
            setError("");
        },
        onError: function(err) {
            var ref;
            var message = (ref = err.response) === null || ref === void 0 ? void 0 : ref.data.message;
            if (typeof message === "string") {
                setError(message);
            }
        }
    }), resendCodeMutation = ref3.mutate, resendCodeLoading = ref3.isLoading;
    var handleResendCodeMutation = function() {
        var username = getValues("username");
        resendCodeMutation({
            username: username
        });
    };
    var handleConfirm = function(e) {
        var ref;
        e.preventDefault();
        var username = getValues("username");
        var code = (ref = codeRef.current) === null || ref === void 0 ? void 0 : ref.value;
        if (!code) {
            var ref1;
            (ref1 = codeRef.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
            return;
        }
        if (!username) {
            setError("Could not find username");
            return;
        }
        confirmSignupMutation({
            username: username,
            code: code
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (confirmationCode_index_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: applyTexts.applicationForm.enterConfirmationCode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "main-input",
                        placeholder: "code",
                        size: 7,
                        ref: codeRef
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (confirmationCode_index_module_default()).resendCode,
                children: [
                    applyTexts.applicationForm.resendCodeText,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: handleResendCodeMutation,
                        children: applyTexts.applicationForm.resendCodeButton
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                isLoading: confirmSignupLoading || loginLoading || resendCodeLoading,
                onClick: handleConfirm,
                children: applyTexts.applicationForm.submit
            })
        ]
    });
};
/* harmony default export */ var confirmationCode = (ApplicationConfirmationCode);

;// CONCATENATED MODULE: ./src/api/media/upload.ts



var getFileMedia = function(param) {
    var fileName = param.fileName, isPublic = param.isPublic, path = param.path;
    try {
        var slugifyFileName = fileName.normalize("NFD").toLocaleLowerCase().replace(/\s/g, "").replace(/[\u0300-\u036f]/g, "");
        return (0,axios/* sendRequest */.wG)({
            method: "post",
            url: "/media/get-upload-path/".concat(slugifyFileName),
            data: {
                isPublic: isPublic,
                path: path
            }
        });
    } catch (error) {
        throw error;
    }
};
var uploadFile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var file, isPublic, path, fileName, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    file = param.file, isPublic = param.isPublic, path = param.path;
                    fileName = file.name;
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return getFileMedia({
                        fileName: fileName,
                        isPublic: isPublic,
                        path: path
                    });
                case 5:
                    res = _ctx.sent;
                    fetch(res.data.url, {
                        method: "put",
                        body: file
                    });
                    return _ctx.abrupt("return", res.data.path);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](2);
                    throw _ctx.t0;
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                10
            ]
        ]);
    }));
    return function uploadFile(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/application/sections/membership/index.tsx










var ApplicationMembership = function() {
    var ref = (0,index_esm/* useFormContext */.Gc)(), getValues = ref.getValues, setValue = ref.setValue;
    var ref1 = (0,react.useState)("YEARLY"), checked = ref1[0], setChecked = ref1[1];
    var ref2 = (0,react.useState)("Upload"), uploadDocumentText = ref2[0], setUploadDocumentText = ref2[1];
    var ref3 = (0,react.useState)(""), errorMessage = ref3[0], setErrorMessage = ref3[1];
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var formTranslations = language === "En" ? en/* default.applyPage.applicationForm */.Z.applyPage.applicationForm : fr/* default.applyPage.applicationForm */.Z.applyPage.applicationForm;
    var handleUploadImage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(files, key) {
            var path, uploadKey;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!files || !files[0])) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        path = key === "idPicturePath" ? "profile/id-cards" : "profile/foreign-residency-documents";
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return uploadFile({
                            file: files[0],
                            isPublic: false,
                            path: path
                        });
                    case 6:
                        uploadKey = _ctx.sent;
                        setValue(key, uploadKey);
                        setUploadDocumentText(formTranslations.uploadSuccessText);
                        _ctx.next = 16;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](3);
                        ;
                        setUploadDocumentText(formTranslations.uploadDocumentText);
                        setErrorMessage(formTranslations.uploadErrorText);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    11
                ]
            ]);
        }));
        return function handleUploadImage(files, key) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSetChecked = function(e) {
        setChecked(e.target.value);
    };
    // isUnder30 gets the value of the birthdate input, subtracts the year of it from the current year to check if the user is over 30
    var birthdate = new Date(getValues("birthDate"));
    birthdate.setFullYear(birthdate.getFullYear() + 30);
    var isUnder30 = birthdate > new Date();
    var internationalMember = getValues("placeOfResidency") != "FR";
    var monthlyPrice = isUnder30 || internationalMember ? 50 : 100;
    var yearlyPrice = isUnder30 || internationalMember ? 600 : 1200;
    (0,react.useEffect)(function() {
        setValue("subscriptionType", isUnder30 || internationalMember ? "REDUCED_MEMBER" : "MEMBER");
    }, [
        isUnder30,
        internationalMember,
        setValue
    ]);
    (0,react.useEffect)(function() {
        var text = getValues("idPicturePath") || getValues("foreignResidencyDocumentPath") ? formTranslations.uploadSuccessText : formTranslations.uploadDocumentText;
        setUploadDocumentText(text);
    }, [
        getValues,
        formTranslations
    ]);
    var InstallmentRadio = function(param) {
        var value = param.value, label = param.label, placeholder = param.placeholder;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
            register: "subscriptionFrequency",
            type: "radio",
            placeholder: placeholder,
            label: label,
            value: value,
            checked: checked === value,
            onClick: handleSetChecked
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isUnder30 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Under 30"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            marginBottom: "0.25rem"
                        },
                        dangerouslySetInnerHTML: {
                            __html: formTranslations.under30Text
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "idPicturePath",
                        label: "id picture",
                        type: "file",
                        fileAccept: [
                            "image/png",
                            "image/jpeg",
                            "image/jpg"
                        ],
                        handleFileUpload: function(e) {
                            handleUploadImage(e.target.files, "idPicturePath");
                        },
                        style: {
                            background: "#fff"
                        },
                        fileUploadText: uploadDocumentText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            marginTop: "0.5rem"
                        },
                        children: formTranslations.imageConditions
                    }),
                    !!errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: errorMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            marginBottom: "0.25rem"
                        },
                        children: formTranslations.installment
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallmentRadio, {
                        placeholder: "Mensuel: ".concat(monthlyPrice, " Euros"),
                        label: "monthly member subscription",
                        value: "MONTHLY"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallmentRadio, {
                        placeholder: "Annuel: ".concat(yearlyPrice, " Euros"),
                        label: "yearly member subscription",
                        value: "YEARLY"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Sponsor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: formTranslations.sponsorMessage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "sponsorCode",
                        placeholder: "Sponsor Code",
                        label: "Sponsor Code"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var membership = (ApplicationMembership);

// EXTERNAL MODULE: ./src/components/application/sections/payment/index.tsx
var payment = __webpack_require__(4347);
// EXTERNAL MODULE: ./src/components/application/ruleOfSilencio/index.module.scss
var ruleOfSilencio_index_module = __webpack_require__(1265);
var ruleOfSilencio_index_module_default = /*#__PURE__*/__webpack_require__.n(ruleOfSilencio_index_module);
;// CONCATENATED MODULE: ./src/components/application/ruleOfSilencio/index.tsx




var ApplicationRulesOfSilencio = function(param) {
    var text = param.text, _termsOfService = param.termsOfService, termsOfService = _termsOfService === void 0 ? false : _termsOfService;
    var ref = (0,react.useState)(false), modalOpen = ref[0], setModalOpen = ref[1];
    var handleCloseModal = function() {
        setModalOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                // onClick={handleOpenModal}
                className: (ruleOfSilencio_index_module_default()).applicationRulesOfSilencio,
                href: termsOfService ? "/termsOfService/Mentions-l\xe9gales-Silencio.pdf" : "https://www.termsfeed.com/live/1d437bd4-aa46-4c95-8bf0-b670f1ed0a9c",
                target: "_blank",
                rel: "noreferrer",
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                open: modalOpen,
                onClose: handleCloseModal,
                showAnimation: "fade-in",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ruleOfSilencio_index_module_default()).applicationRulesOfSilencioModal,
                    children: "Lorem Ipsum"
                })
            })
        ]
    });
};
/* harmony default export */ var ruleOfSilencio = (ApplicationRulesOfSilencio);

;// CONCATENATED MODULE: ./src/utils/constants/countries.ts
var countries = {
    AF: "Afghanistan",
    AX: "Aland Islands",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctica",
    AG: "Antigua and Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BQ: "Bonaire, Sint Eustatius and Saba",
    BA: "Bosnia and Herzegovina",
    BW: "Botswana",
    BV: "Bouvet Island",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CG: "Congo",
    CD: "Congo, the Democratic Republic of the",
    CK: "Cook Islands",
    CR: "Costa Rica",
    CI: "Cote D'Ivoire",
    HR: "Croatia",
    CU: "Cuba",
    CW: "Curacao",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FK: "Falkland Islands (Malvinas)",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "French Polynesia",
    TF: "French Southern Territories",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard Island and Mcdonald Islands",
    VA: "Holy See (Vatican City State)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran, Islamic Republic of",
    IQ: "Iraq",
    IE: "Ireland",
    IM: "Isle of Man",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JE: "Jersey",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KP: "Korea, Democratic People's Republic of",
    KR: "Korea, Republic of",
    XK: "Kosovo",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Lao People's Democratic Republic",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libyan Arab Jamahiriya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MK: "Macedonia, the Former Yugoslav Republic of",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia, Federated States of",
    MD: "Moldova, Republic of",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    AN: "Netherlands Antilles",
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestinian Territory, Occupied",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: "Pitcairn",
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RU: "Russian Federation",
    RW: "Rwanda",
    BL: "Saint Barthelemy",
    SH: "Saint Helena",
    KN: "Saint Kitts and Nevis",
    LC: "Saint Lucia",
    MF: "Saint Martin",
    PM: "Saint Pierre and Miquelon",
    VC: "Saint Vincent and the Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome and Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    CS: "Serbia and Montenegro",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SX: "Sint Maarten",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia and the South Sandwich Islands",
    SS: "South Sudan",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard and Jan Mayen",
    SZ: "Swaziland",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syrian Arab Republic",
    TW: "Taiwan, Province of China",
    TJ: "Tajikistan",
    TZ: "Tanzania, United Republic of",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad and Tobago",
    TN: "Tunisia",
    TR: "Turkey",
    TM: "Turkmenistan",
    TC: "Turks and Caicos Islands",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States",
    UM: "United States Minor Outlying Islands",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Viet Nam",
    VG: "Virgin Islands, British",
    VI: "Virgin Islands, U.s.",
    WF: "Wallis and Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe"
};
var nationalities = {
    GB: "British",
    AF: "Afghan",
    AL: "Albanian",
    DZ: "Algerian",
    US: "American",
    AD: "Andorran",
    AO: "Angolan",
    AM: "Armenian",
    AT: "Austrian",
    AZ: "Azerbaijani",
    AR: "Argentinian",
    AU: "Australian",
    BH: "Bahraini",
    BD: "Bangladeshi",
    BB: "Barbadian",
    BY: "Belarusian",
    BZ: "Belizean",
    BJ: "Beninese",
    BM: "Bermudian",
    BT: "Bhutanese",
    BO: "Bolivian",
    BA: "Bosnian",
    BW: "Botswanan",
    BG: "Bulgarian",
    BF: "Burkinese",
    BI: "Burundian",
    CA: "Canadian",
    CN: "Chinese",
    CO: "Colombian",
    CU: "Cuban",
    KH: "Cambodian",
    CM: "Cameroonian",
    CV: "Cape Verdean",
    TD: "Chadian",
    CL: "Chilean",
    CG: "Congolese",
    CR: "Costa Rican",
    HR: "Croat",
    CY: "Cypriot",
    CZ: "Czech",
    DK: "Danish",
    DO: "Dominican",
    DJ: "Djiboutian",
    DM: "Dominican",
    NL: "Dutch",
    EC: "Ecuadorean",
    EG: "Egyptian",
    ER: "Eritrean",
    EE: "Estonian",
    ET: "Ethiopian",
    FJ: "Fijian",
    FI: "Finnish",
    PF: "Fran\xe7ais Polynesian",
    FR: "Fran\xe7ais",
    GA: "Gabonese",
    GM: "Gambian",
    GE: "Georgian",
    DE: "German",
    GT: "Guatemalan",
    GH: "Ghanaian",
    GR: "Greek",
    GD: "Grenadian",
    GN: "Guinean",
    GY: "Guyanese",
    HT: "Haitian",
    HN: "Honduran",
    HU: "Hungarian",
    IN: "Indian",
    IE: "Ireland",
    IL: "Israeli",
    IT: "Italian",
    IS: "Icelandic",
    ID: "Indonesian",
    IR: "Iranian",
    IQ: "Iraqi",
    JP: "Japanese",
    JM: "Jamaican",
    JO: "Jordanian",
    KZ: "Kazakh",
    KE: "Kenyan",
    KP: "North Korean",
    KW: "Kuwaiti",
    LV: "Latvian",
    LB: "Lebanese",
    LR: "Liberian",
    LY: "Libyan",
    LT: "Lithuanian",
    LU: "LUXEMBOURG",
    MG: "Madagascan",
    MW: "Malawian",
    MY: "Malaysian",
    MV: "Maldivian",
    ML: "Malian",
    MT: "Maltese",
    MR: "Mauritanian",
    MU: "Mauritian",
    MC: "Monacan",
    MN: "Mongolian",
    ME: "Montenegrin",
    MA: "Moroccan",
    MZ: "Mozambican",
    MX: "Mexican",
    NA: "Namibian",
    NP: "Nepalese",
    NZ: "New Zealand",
    NI: "Nicaraguan",
    NE: "Nigerien",
    NG: "Nigerian",
    NO: "Norwegian",
    OM: "Omani",
    PK: "Pakistani",
    PA: "Panamanian",
    PG: "Guinean",
    PY: "Paraguayan",
    PE: "Peruvian",
    PH: "Philippine",
    PL: "Polish",
    PT: "Portuguese",
    QA: "Qatari",
    RO: "Romanian",
    RW: "Rwandan",
    SV: "Salvadorean",
    AS: "Samoan",
    SA: "Saudi Arabian",
    SN: "Senegalese",
    RS: "Serbian",
    SL: "Sierra Leonian",
    SG: "Singaporean",
    SK: "Slovak",
    SI: "Slovenian",
    SB: "Slomoni",
    SO: "Somali",
    ZA: "South African",
    KR: "South Korean",
    ES: "Spanish",
    SE: "Swedish",
    CH: "Swiss",
    LK: "Sri Lankan",
    SD: "Sudanese",
    SR: "Surinamese",
    SZ: "Swazi",
    TW: "Taiwanese",
    TJ: "Tajik",
    TH: "Thai",
    TG: "Togolese",
    TT: "Trinidadian",
    TN: "Tunisian",
    TR: "Turkish",
    TM: "Turkoman",
    TV: "Tuvaluan",
    UG: "Ugandan",
    UA: "Ukrainian",
    AE: "Emirati",
    VE: "Venezuelan",
    VN: "Vietnamese",
    UY: "Uruguayan",
    UZ: "Uzbek",
    VU: "Vanuatuan",
    YE: "Yemeni",
    ZM: "Zambian"
};

;// CONCATENATED MODULE: ./src/utils/constants/genders.ts
var genders = {
    MALE: "Masculin",
    FEMALE: "F\xe9minin",
    AGENDER: "Agenre",
    NON_BINARY: "Non Binaire",
    QUEER: "Queer"
};
var gendersEn = {
    MALE: "Male",
    FEMALE: "Female",
    AGENDER: "Agender",
    NON_BINARY: "Non Binary",
    QUEER: "Queer"
};

// EXTERNAL MODULE: ./src/utils/functions/general.functions.ts
var general_functions = __webpack_require__(337);
;// CONCATENATED MODULE: ./src/components/application/sections/personalInformation/addressAndBirthdate/index.tsx










var ApplicationAboutYouAddressAndBirthday = function() {
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var applyTexts = language === "En" ? en/* default.applyPage */.Z.applyPage : fr/* default.applyPage */.Z.applyPage;
    var nationalitySelectOptions = (0,react.useMemo)(function() {
        return (0,general_functions/* objectToSelectionSet */.st)(nationalities);
    }, [
        nationalities,
        general_functions/* objectToSelectionSet */.st
    ]);
    var genderSelectOptions = (0,react.useMemo)(function() {
        return (0,general_functions/* objectToSelectionSet */.st)(language === "En" ? gendersEn : genders);
    }, [
        language,
        genders,
        gendersEn,
        general_functions/* objectToSelectionSet */.st
    ]);
    var placeOfResidencySelectOptions = (0,react.useMemo)(function() {
        return (0,general_functions/* objectToSelectionSet */.st)(countries);
    }, [
        countries,
        general_functions/* objectToSelectionSet */.st
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Coordonn\xe9es"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "phoneNumber",
                        placeholder: applyTexts.applicationForm.phoneNumber,
                        label: applyTexts.applicationForm.phoneNumber,
                        required: true,
                        size: 13
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "addressLine1",
                        placeholder: applyTexts.applicationForm.address1,
                        label: applyTexts.applicationForm.address1,
                        size: 12
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "addressLine2",
                        placeholder: applyTexts.applicationForm.address2,
                        label: applyTexts.applicationForm.address2,
                        size: 12
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "city",
                        placeholder: applyTexts.applicationForm.city,
                        label: applyTexts.applicationForm.city,
                        size: 4
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "postalCode",
                        placeholder: applyTexts.applicationForm.postalCode,
                        label: applyTexts.applicationForm.postalCode,
                        size: 12
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: applyTexts.applicationForm.dob
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "birthDate",
                        placeholder: "Birth Date MM/DD/YYYY",
                        label: "birthDate",
                        type: "date",
                        required: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "nationality",
                        placeholder: "Fran\xe7ais",
                        label: "nationality",
                        type: "select",
                        required: true,
                        selectOptions: nationalitySelectOptions,
                        defaultValue: "FR"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "gender",
                        placeholder: applyTexts.applicationForm.gender,
                        label: applyTexts.applicationForm.gender,
                        type: "select",
                        required: true,
                        selectOptions: genderSelectOptions
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "placeOfResidency",
                        placeholder: applyTexts.applicationForm.por,
                        label: applyTexts.applicationForm.por,
                        type: "select",
                        required: true,
                        selectOptions: placeOfResidencySelectOptions
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "*",
                    applyTexts.applicationForm.dataStore,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ruleOfSilencio, {
                        text: "→ ".concat(applyTexts.applicationForm.privacyPolicy)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var addressAndBirthdate = (ApplicationAboutYouAddressAndBirthday);

;// CONCATENATED MODULE: ./src/components/application/sections/personalInformation/job/index.tsx






var ApplicationAboutYouJob = function() {
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var applyTexts = language === "En" ? en/* default.applyPage */.Z.applyPage : fr/* default.applyPage */.Z.applyPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: applyTexts.applicationForm.job
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "industry",
                        placeholder: applyTexts.applicationForm.industry,
                        label: "industry",
                        size: 7,
                        required: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "jobTitle",
                        placeholder: applyTexts.applicationForm.jobTitle,
                        label: "job title",
                        size: 7,
                        required: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "companyName",
                        placeholder: applyTexts.applicationForm.companyName,
                        label: "company name",
                        size: 12,
                        required: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "professionalEmail",
                        placeholder: applyTexts.applicationForm.professionalEmail,
                        label: "professional email",
                        size: 23
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "workTown",
                        placeholder: applyTexts.applicationForm.town,
                        label: "town",
                        size: 4
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "*",
                    applyTexts.applicationForm.dataStore,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ruleOfSilencio, {
                        text: "→ ".concat(applyTexts.applicationForm.privacyPolicy)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var job = (ApplicationAboutYouJob);

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(1296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
;// CONCATENATED MODULE: ./src/api/auth/checkAvailability.ts



var checkAvailability = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(email) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,axios/* sendRequest */.wG)({
                        method: "get",
                        url: "/auth/check-availability?email=".concat(email)
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function checkAvailability(email) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/utils/constants/regex.ts
var regex = __webpack_require__(3036);
;// CONCATENATED MODULE: ./src/components/application/sections/personalInformation/login/index.tsx













var ApplicationAboutYouLogin = function(param) {
    var passwordText = param.passwordText, handleSetPasswordText = param.handleSetPasswordText;
    var setFocus = (0,index_esm/* useFormContext */.Gc)().setFocus;
    var ref = (0,react.useState)(""), emailText = ref[0], setEmailText = ref[1];
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var applyTexts = language === "En" ? en/* default.applyPage */.Z.applyPage : fr/* default.applyPage */.Z.applyPage;
    var handleSetEmailText = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(email) {
            var available;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return checkAvailability(email);
                    case 2:
                        available = _ctx.sent;
                        if (!available) {
                            setEmailText(language === "En" ? "This email is already linked to an account" : "Cet email est d\xe9j\xe0 rattach\xe9 \xe0 un compte");
                            setTimeout(function() {
                                setFocus("email");
                            }, 10);
                        } else {
                            setEmailText("");
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setFocus,
        language
    ]);
    var debouncedhandleSetEmailText = (0,react.useMemo)(function() {
        return lodash_debounce_default()(handleSetEmailText, 300);
    }, [
        handleSetEmailText
    ]);
    var handleSetPasswordChange = function(e) {
        if (e.target.value !== "") {
            handleSetPasswordText("");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: applyTexts.applicationForm.login
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "email",
                        placeholder: "Email",
                        label: "Email",
                        required: true,
                        size: 18,
                        options: {
                            pattern: regex/* emailRegex */.H
                        },
                        onChange: function(e) {
                            debouncedhandleSetEmailText(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: emailText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "password",
                        placeholder: applyTexts.applicationForm.password,
                        label: applyTexts.applicationForm.password,
                        type: "password",
                        size: 20,
                        required: true,
                        onChange: handleSetPasswordChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: passwordText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "confirmPassword",
                        placeholder: "".concat(applyTexts.applicationForm.confirmPassword, "*"),
                        label: "".concat(applyTexts.applicationForm.confirmPassword, "*"),
                        type: "password",
                        size: 22
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "*",
                    applyTexts.applicationForm.dataStore,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ruleOfSilencio, {
                        text: "→ ".concat(applyTexts.applicationForm.privacyPolicy)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var login = (ApplicationAboutYouLogin);

// EXTERNAL MODULE: ./src/components/application/sections/profilePicture/index.module.scss
var profilePicture_index_module = __webpack_require__(3609);
var profilePicture_index_module_default = /*#__PURE__*/__webpack_require__.n(profilePicture_index_module);
;// CONCATENATED MODULE: ./src/components/application/sections/profilePicture/index.tsx












var ApplicationProfilePicture = function() {
    var ref;
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), setValue = ref1.setValue, resetField = ref1.resetField, clearErrors = ref1.clearErrors, errors = ref1.formState.errors;
    var ref2 = (0,react.useState)(""), imageUrl = ref2[0], setImageUrl = ref2[1];
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var applyTexts = language === "En" ? en/* default.applyPage */.Z.applyPage : fr/* default.applyPage */.Z.applyPage;
    var handleSetImageUrl = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(files) {
            var key;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return uploadFile({
                            file: files[0],
                            isPublic: true,
                            path: "profile/pictures"
                        });
                    case 4:
                        key = _ctx.sent;
                        setImageUrl(URL.createObjectURL(files[0]));
                        clearErrors("profilePicturePath");
                        setValue("profilePicturePath", key);
                        _ctx.next = 14;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        resetField("profilePicturePath");
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10
                ]
            ]);
        }));
        return function(files) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setImageUrl,
        setValue
    ]);
    var handleUploadImage = function(e) {
        if (!e.target.files) return;
        handleSetImageUrl(e.target.files);
    };
    var handlePasteImage = (0,react.useCallback)(function(e) {
        var data = e.clipboardData;
        if (data) {
            handleSetImageUrl(e.clipboardData.files);
        }
    }, [
        handleSetImageUrl
    ]);
    (0,react.useEffect)(function() {
        document.addEventListener("paste", handlePasteImage);
        return function() {
            document.removeEventListener("paste", handlePasteImage);
        };
    }, [
        handlePasteImage
    ]);
    var errorMessage = (ref = errors.profilePicturePath) === null || ref === void 0 ? void 0 : ref.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: applyTexts.applicationForm.uploadPhotoText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    applyTexts.applicationForm.uploadPhotoPolicy,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ruleOfSilencio, {
                        text: " → ".concat(applyTexts.applicationForm.privacyPolicy)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (profilePicture_index_module_default()).applicationPictureInputContainer,
                children: imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                        className: (profilePicture_index_module_default()).picture,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (profilePicture_index_module_default()).cancel,
                                onClick: function() {
                                    setImageUrl("");
                                    resetField("profilePicturePath");
                                },
                                children: "X"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: imageUrl,
                                alt: "profile picture"
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "profilePicturePath",
                        label: "card number",
                        type: "file",
                        fileAccept: [
                            "image/png",
                            "image/jpeg",
                            "image/jpg"
                        ],
                        handleFileUpload: handleUploadImage,
                        value: imageUrl
                    })
                })
            }),
            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: errorMessage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: applyTexts.applicationForm.imageDescription
            })
        ]
    });
};
/* harmony default export */ var profilePicture = (ApplicationProfilePicture);

;// CONCATENATED MODULE: ./src/api/auth/suggestUsername.ts



var suggestUsername = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
        var firstname, lastname, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    firstname = input.firstname, lastname = input.lastname;
                    _ctx.next = 3;
                    return (0,axios/* sendRequest */.wG)({
                        method: "get",
                        url: "/auth/suggest-username?firstname=".concat(firstname, "&lastname=").concat(lastname)
                    });
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", {
                        success: true,
                        data: res.data
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function suggestUsername(input) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/application/sections/startMembership/index.tsx












var ApplicationStartMembership = function() {
    var ref = (0,index_esm/* useFormContext */.Gc)(), setValue = ref.setValue, getValues = ref.getValues, setFocus = ref.setFocus;
    var ref1 = (0,react.useState)(false), usernameManipulated = ref1[0], setUsernameManipulated = ref1[1];
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var applyTexts = language === "En" ? en/* default.applyPage */.Z.applyPage : fr/* default.applyPage */.Z.applyPage;
    var handleSetUsername = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(inputName) {
            var ref, firstname, lastname, suggestedUsername;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = getValues(), firstname = ref.firstname, lastname = ref.lastname;
                        if (!(!firstname || !lastname || usernameManipulated)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return suggestUsername({
                            firstname: firstname,
                            lastname: lastname
                        });
                    case 5:
                        suggestedUsername = _ctx.sent;
                        setValue("username", suggestedUsername.data);
                        setTimeout(function() {
                            if (inputName === "firstname" || inputName === "lastname") setFocus(inputName);
                        }, 10);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(inputName) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getValues,
        setFocus,
        setValue,
        usernameManipulated
    ]);
    var debouncedhandleSetUsername = (0,react.useMemo)(function() {
        return lodash_debounce_default()(handleSetUsername, 300);
    }, [
        handleSetUsername
    ]);
    var handleSetUsernameManipulated = function() {
        setUsernameManipulated(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: applyTexts.applicationForm.applyForMembership
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: applyTexts.applicationForm.text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "firstname",
                        placeholder: applyTexts.applicationForm.firstName,
                        label: applyTexts.applicationForm.firstName,
                        required: true,
                        onChange: function(e) {
                            debouncedhandleSetUsername(e.target.name);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "lastname",
                        placeholder: applyTexts.applicationForm.lastName,
                        label: applyTexts.applicationForm.lastName,
                        required: true,
                        onChange: function(e) {
                            debouncedhandleSetUsername(e.target.name);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "username",
                        placeholder: applyTexts.applicationForm.username,
                        label: applyTexts.applicationForm.username,
                        required: true,
                        onChange: handleSetUsernameManipulated
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: applyTexts.applicationForm.confirmRules
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "acceptRules",
                        label: "accept the rules of Silencio",
                        type: "checkbox",
                        required: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    language === "Fr" ? "En vous inscrivant, vous acceptez la" : "By registering, you agree to Silencio's",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ruleOfSilencio, {
                        text: language === "Fr" ? "→ politique de confidentialit\xe9" : "→ Privacy Policy"
                    }),
                    " ",
                    language === "Fr" ? "et les" : "and",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ruleOfSilencio, {
                        termsOfService: true,
                        text: language === "Fr" ? "→ conditions d’utilisation." : "→ Terms and Conditions."
                    }),
                    " ",
                    applyTexts.applicationForm.changeLaterText
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: applyTexts.applicationForm.receiveNewsletter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        register: "newsletters",
                        label: "receive updates, news and offers from Silencio and its affiliates",
                        type: "checkbox"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var startMembership = (ApplicationStartMembership);

// EXTERNAL MODULE: ./src/components/application/sections/success/index.tsx
var success = __webpack_require__(1782);
;// CONCATENATED MODULE: ./src/components/application/sections/index.tsx













var ApplicationSections = function(param) {
    var step = param.step, reachedStep = param.reachedStep, passwordText = param.passwordText, handleSetPasswordText = param.handleSetPasswordText, goToNextStep = param.goToNextStep;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(startMembership, {}, "application-section-ApplicationStartMembership"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(login, {
                passwordText: passwordText,
                handleSetPasswordText: handleSetPasswordText
            }, "application-section-ApplicationAboutYouLogin"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(addressAndBirthdate, {}, "application-section-ApplicationAboutYouAddressAndBirthday"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(job, {}, "application-section-ApplicationAboutYouJob"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(profilePicture, {}, "application-section-ApplicationProfilePicture"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(biographyAndJoining, {}, "application-section-ApplicationBiographyAndJoining"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(socials, {}, "application-section-ApplicationAboutYouSocials"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(membership, {}, "application-section-ApplicationMembership"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(confirmationCode, {
                goToNextStep: goToNextStep
            }, "application-section-ApplicationConfirmationCode"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(payment/* default */.Z, {
                handleNext: goToNextStep
            }, "application-section-ApplicationPayment"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(success/* default */.Z, {}, "application-section-ApplicationSuccessful"), 
        ].map(function(section, i) {
            return(// i >= 8 &&
            i >= 0 && reachedStep >= i && /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset, {
                hidden: step != i,
                children: section
            }, "membership-application-section-".concat(i)));
        })
    });
};
/* harmony default export */ var sections = (ApplicationSections);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/ui/loader/index.tsx
var loader = __webpack_require__(8408);
// EXTERNAL MODULE: ./src/contexts/providers/auth.tsx
var auth = __webpack_require__(7322);
// EXTERNAL MODULE: ./src/types/auth/userEnums.types.ts
var userEnums_types = __webpack_require__(5997);
// EXTERNAL MODULE: ./src/utils/pages/index.ts
var pages = __webpack_require__(2305);
// EXTERNAL MODULE: ./src/components/wrappers/UnauthenticatedPage/index.module.scss
var UnauthenticatedPage_index_module = __webpack_require__(1474);
var UnauthenticatedPage_index_module_default = /*#__PURE__*/__webpack_require__.n(UnauthenticatedPage_index_module);
;// CONCATENATED MODULE: ./src/components/wrappers/UnauthenticatedPage/index.tsx








var UnauthenticatedPage = function(param) {
    var children = param.children;
    var user = (0,auth/* useAuth */.aC)().user;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if ((user === null || user === void 0 ? void 0 : user.id) && user.status === userEnums_types/* UserStatus.VALIDATED */.J0.VALIDATED) router.push("".concat(pages/* HOME_PAGE */.s));
    }, [
        router,
        user
    ]);
    if (!((user === null || user === void 0 ? void 0 : user.id) && user.status === userEnums_types/* UserStatus.VALIDATED */.J0.VALIDATED)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (UnauthenticatedPage_index_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* Loader */.a, {})
    });
};
/* harmony default export */ var wrappers_UnauthenticatedPage = (UnauthenticatedPage);

// EXTERNAL MODULE: ./src/pages/apply/index.module.scss
var apply_index_module = __webpack_require__(6948);
var apply_index_module_default = /*#__PURE__*/__webpack_require__.n(apply_index_module);
;// CONCATENATED MODULE: ./src/pages/apply/index.tsx





















var ApplicationPage = function() {
    var ref = (0,react.useState)(""), clientSecret = ref[0];
    var methods = (0,index_esm/* useForm */.cI)();
    var ref1 = (0,react.useState)(0), step = ref1[0], setStep = ref1[1];
    var ref2 = (0,react.useState)(1), reachedStep = ref2[0], setReachedStep = ref2[1];
    var ref3 = (0,react.useState)(""), passwordText = ref3[0], setPasswordText = ref3[1];
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var applyTexts = language === "En" ? en/* default.applyPage */.Z.applyPage : fr/* default.applyPage */.Z.applyPage;
    var ref4 = (0,es.useMutation)(signupUser, {
        onSuccess: function() {
            setStep(function(prev) {
                return prev + 1;
            });
            setReachedStep(function(prev) {
                return prev + 1;
            });
        }
    }), signupMutation = ref4.mutate;
    var handleSetPasswordText = function(text) {
        setPasswordText(text);
    };
    var handleSubmit = function(data) {
        //MUST handle this appropriately
        delete data.confirmPassword;
        delete data.acceptRules;
        delete data.acceptHealthStatement;
        (0,general_functions/* getObjectKeys */.Zt)(data).forEach(function(key) {
            var val = data[key];
            if (val === "" || val === "$_DEFAULT_VALUE_$") {
                delete data[key];
            }
        });
        signupMutation(data);
    };
    var checkStepValidity = function() {
        for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++){
            keys[_key] = arguments[_key];
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (!methods.getValues(key)) {
                    methods.setFocus(key);
                    return false;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    };
    var passwordValidation = function(password) {
        if (password == "") return "";
        var error = [];
        if (password.length < 8) error.push(applyTexts.applicationForm.minimumCharacters);
        if (!password.match(/[a-z]/)) error.push(applyTexts.applicationForm.lowerCase);
        if (!password.match(/[A-Z]/)) error.push(applyTexts.applicationForm.upperCase);
        if (!password.match(/[0-9]/)) error.push(applyTexts.applicationForm.number);
        if (!password.match(/[^a-zA-Z0-9]/)) error.push(applyTexts.applicationForm.specialCharacter);
        return error.join(", ");
    };
    var checkRegex = function(key, regex, handleSetErrorMessage) {
        if (!regex.test(methods.getValues(key))) {
            if (handleSetErrorMessage) handleSetErrorMessage();
            methods.setFocus(key);
            return false;
        }
        return true;
    };
    var checkConfirmPassword = function() {
        if (methods.getValues("password") != methods.getValues("confirmPassword")) {
            methods.setFocus("confirmPassword");
            return false;
        }
        return true;
    };
    var checkDate = function(key) {
        var min = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        var date = new Date(methods.getValues(key));
        if (!date || "".concat(date) == "Invalid Date" || // since this is a date the value should not be greater than min or less than max unlike a normal number
        (!!min && date.valueOf() > min.valueOf()) || !!max && date.valueOf() < max.valueOf()) {
            methods.setFocus(key);
            return false;
        }
        return true;
    };
    var checkEmailAvailability = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var available;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,axios/* sendRequest */.wG)({
                            method: "get",
                            url: "/auth/check-availability?email=".concat(methods.getValues("email"))
                        });
                    case 2:
                        available = _ctx.sent;
                        if (available) {
                            _ctx.next = 7;
                            break;
                        }
                        methods.setError("email", {
                            type: "manual",
                            message: language === "En" ? "This email is already linked to an account" : "Cet email est d\xe9j\xe0 rattach\xe9 \xe0 un compte"
                        });
                        methods.setFocus("email");
                        return _ctx.abrupt("return", false);
                    case 7:
                        return _ctx.abrupt("return", true);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkEmailAvailability() {
            return _ref.apply(this, arguments);
        };
    }();
    var checkUsernameAvailability = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var available;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,axios/* sendRequest */.wG)({
                            method: "get",
                            url: "/auth/check-availability?username=".concat(methods.getValues("username"))
                        });
                    case 2:
                        available = _ctx.sent;
                        if (available) {
                            _ctx.next = 7;
                            break;
                        }
                        methods.setError("username", {
                            type: "manual",
                            message: "Nom d’utilisateur d\xe9j\xe0 utilis\xe9"
                        });
                        methods.setFocus("username");
                        return _ctx.abrupt("return", false);
                    case 7:
                        return _ctx.abrupt("return", true);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkUsernameAvailability() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBack = function(e) {
        e.preventDefault();
        setStep(function(prev) {
            return prev - 1;
        });
    };
    var handleNext = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var date18YearsAgo;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.t0 = step;
                        _ctx.next = _ctx.t0 === 0 ? 3 : _ctx.t0 === 1 ? 11 : _ctx.t0 === 2 ? 19 : _ctx.t0 === 3 ? 24 : _ctx.t0 === 4 ? 27 : _ctx.t0 === 5 ? 31 : _ctx.t0 === 7 ? 34 : 36;
                        break;
                    case 3:
                        _ctx.t1 = !checkStepValidity("firstname", "lastname", "username");
                        if (_ctx.t1) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 7;
                        return checkUsernameAvailability();
                    case 7:
                        _ctx.t1 = !_ctx.sent;
                    case 8:
                        if (!_ctx.t1) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 10:
                        return _ctx.abrupt("break", 36);
                    case 11:
                        _ctx.t2 = !checkRegex("email", regex/* emailRegex */.H) || !checkRegex("password", regex/* passwordRegex */.B, function() {
                            handleSetPasswordText(passwordValidation(methods.getValues("password")));
                        }) || !checkConfirmPassword();
                        if (_ctx.t2) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 15;
                        return checkEmailAvailability();
                    case 15:
                        _ctx.t2 = !_ctx.sent;
                    case 16:
                        if (!_ctx.t2) {
                            _ctx.next = 18;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 18:
                        return _ctx.abrupt("break", 36);
                    case 19:
                        date18YearsAgo = new Date(Date.now());
                        date18YearsAgo.setFullYear(date18YearsAgo.getFullYear() - 18);
                        if (!(!checkStepValidity("phoneNumber") || !checkDate("birthDate", date18YearsAgo))) {
                            _ctx.next = 23;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 23:
                        return _ctx.abrupt("break", 36);
                    case 24:
                        if (checkStepValidity("industry", "jobTitle", "companyName")) {
                            _ctx.next = 26;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 26:
                        return _ctx.abrupt("break", 36);
                    case 27:
                        if (methods.getValues("profilePicturePath")) {
                            _ctx.next = 30;
                            break;
                        }
                        methods.setError("profilePicturePath", {
                            message: language === "En" ? "Please upload a profile picture" : "Veuillez t\xe9l\xe9charger une photo de profil"
                        });
                        return _ctx.abrupt("return");
                    case 30:
                        return _ctx.abrupt("break", 36);
                    case 31:
                        if (checkStepValidity("shortBiography", "joiningSilencio")) {
                            _ctx.next = 33;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 33:
                        return _ctx.abrupt("break", 36);
                    case 34:
                        handleSubmit(methods.getValues());
                        return _ctx.abrupt("return");
                    case 36:
                        setStep(function(prev) {
                            return prev + 1;
                        });
                        if (reachedStep == step) {
                            setReachedStep(function(prev) {
                                return prev + 1;
                            });
                        }
                    case 38:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleNext() {
            return _ref.apply(this, arguments);
        };
    }();
    var goToNextStep = function() {
        setStep(function(prev) {
            return prev + 1;
        });
        setReachedStep(function(prev) {
            return prev + 1;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(wrappers_UnauthenticatedPage, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "Silencio - ",
                        applyTexts.title
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (apply_index_module_default()).applicationFormContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: function() {
                            methods.handleSubmit(handleSubmit);
                        },
                        className: (apply_index_module_default()).applicationForm,
                        autoComplete: "off",
                        children: [
                            step !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(nextStep, {
                                currentStep: step
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sections, {
                                clientSecret: clientSecret,
                                step: step,
                                reachedStep: reachedStep,
                                passwordText: passwordText,
                                handleSetPasswordText: handleSetPasswordText,
                                goToNextStep: goToNextStep
                            }),
                            step < 8 && /*#__PURE__*/ (0,jsx_runtime.jsx)(navigationButtons, {
                                step: step,
                                handleBack: handleBack,
                                handleNext: function(e) {
                                    if (step < 8) e.preventDefault();
                                    handleNext();
                                }
                            })
                        ]
                    })
                })
            }))
        ]
    });
};
/* harmony default export */ var apply = (ApplicationPage);


/***/ }),

/***/ 2305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ HOME_PAGE; }
/* harmony export */ });
var HOME_PAGE = "/";


/***/ }),

/***/ 7734:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"applicationFieldset":"fieldset_applicationFieldset__dVdIz","accordion-open":"fieldset_accordion-open__aa2l1","hidden":"fieldset_hidden__wGhQi"};

/***/ }),

/***/ 2471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"datePicker_container__KLffZ","calendar":"datePicker_calendar__OM1N1","day":"datePicker_day__q6TLs","inputContainer":"datePicker_inputContainer__ltyoY"};

/***/ }),

/***/ 4350:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"applicationInputLabel":"input_applicationInputLabel__pvCCU","applicationInput":"input_applicationInput__MdQ4t","checkboxContainer":"input_checkboxContainer__XtfR9"};

/***/ }),

/***/ 9633:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"applicationNavigationButtons":"navigationButtons_applicationNavigationButtons__Vw0xY","disabled":"navigationButtons_disabled__QCFM4"};

/***/ }),

/***/ 800:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"applicationNextStep":"nextStep_applicationNextStep__BW7Z7","fade-in":"nextStep_fade-in__T48bS","stepButton":"nextStep_stepButton__3JrjR"};

/***/ }),

/***/ 1265:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"applicationRulesOfSilencio":"ruleOfSilencio_applicationRulesOfSilencio__7jfTM","applicationRulesOfSilencioModal":"ruleOfSilencio_applicationRulesOfSilencioModal__OCq_U"};

/***/ }),

/***/ 6931:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"confirmationCode_container__s5DZK","resendCode":"confirmationCode_resendCode__EU0U6"};

/***/ }),

/***/ 3609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"applicationPictureInputContainer":"profilePicture_applicationPictureInputContainer__wNLqg","fade-in":"profilePicture_fade-in__s4J_p","fade-in-out":"profilePicture_fade-in-out__AQMQY","animate":"profilePicture_animate__n9dZO","pictureDropModal":"profilePicture_pictureDropModal__HDkbT","picture":"profilePicture_picture__9T_EF","cancel":"profilePicture_cancel__2trMK"};

/***/ }),

/***/ 2519:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"loader_loading__j20tW","loading06":"loader_loading06__7eG1M"};

/***/ }),

/***/ 1474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"UnauthenticatedPage_container__F3Bsx","loader":"UnauthenticatedPage_loader__KeOyE","spin":"UnauthenticatedPage_spin__iYPOZ"};

/***/ }),

/***/ 6948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"applicationFormContainer":"apply_applicationFormContainer__VaQvz","applicationForm":"apply_applicationForm__ouIla"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [308,399,774,888,179], function() { return __webpack_exec__(7174); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);